import BrokerDuckContainer from "./BrokerDuckContainer";

export default BrokerDuckContainer;